import React, { Component } from 'react';

import './styles.less';

export default class Checkbox extends Component {
  render() {
    const {
      checkboxId,
      isDisabled,
      isChecked,
      innerShadow = false,
    } = this.props;

    return (
      <div
        className={`checkbox-container ${innerShadow ? 'inner-shadow' : ''}`}
        onClick={this.handleClick}
      >
        <input
          type="checkbox"
          checked={isChecked}
          id={checkboxId}
          disabled={isDisabled}
          onChange={this.toggleCheckbox}
        />
        <label htmlFor={checkboxId} />
      </div>
    );
  }

  handleClick = e => {
    const { checkboxId } = this.props;

    e.stopPropagation();

    if (e.target.htmlFor === checkboxId || e.target.id === checkboxId) {
      return;
    }

    this.toggleCheckbox();
  };

  toggleCheckbox = () => {
    const { isChecked, onDisable, onEnable } = this.props;

    if (isChecked) {
      onDisable();
    } else {
      onEnable();
    }
  };
}
